import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { getStorage } from 'firebase/storage'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'

const firebaseConfig = {
    apiKey: "AIzaSyA_MfcJylqjCrOstfeUGVJaHNCzmEbVoPY",
    authDomain: "plus1-8ea63.firebaseapp.com",
    projectId: "plus1-8ea63",
    storageBucket: "plus1-8ea63.appspot.com",
    messagingSenderId: "593089382507",
    appId: "1:593089382507:web:10d404d202cc3d6425492e",
    measurementId: "G-4829LLX1TC"
  }

  // init firebase
  const app = initializeApp(firebaseConfig)

  // init firestore
  const db = getFirestore()

  // init firebase auth
  const auth = getAuth()

  // init firebase storage
  const storage = getStorage()

  // intialize firebase functions
  const functions = getFunctions(app)
  //connectFunctionsEmulator(functions, "localhost", 5001)

  export { db, auth, storage, functions, onAuthStateChanged }